import React, { useState, useEffect } from 'react'
import "./carousel.css"
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import axios from "axios"
import { img_300, noPicture } from "../config/config";


const Carousel = ({id, mediaType}) => {
  const [credits, setCredits] = useState([])

  const handleDragStart = (e) => e.preventDefault();

  const fetchCredits = () => {
    axios.get(`https://api.themoviedb.org/3/${mediaType}/${id}/credits?api_key=${process.env.REACT_APP_API_KEY}&language=en-US`)
      .then(res => {
        setCredits(res.data.cast);
      })
      .catch(err => {
        console.log(err)
      })
    
  };
  useEffect(() => {
    fetchCredits();
    // eslint-disable-next-line
  }, []);

  
  // const items = [
  //   <img src="path-to-img" onDragStart={handleDragStart} />,
  //   <img src="path-to-img" onDragStart={handleDragStart} />,
  // ];
  const actors = credits.map(credit => {
    // console.log(credit)
    return <div className='actor-card'>
      <img className='actor-img' src={`${img_300}${credit.profile_path}`} alt="" />
      <p className='actor-name'>{credit.name}</p>
      <i className='character'>{credit.character}</i>
    </div>
  })

  return (
    <AliceCarousel className="carousel" items={actors}
        mouseTracking
        infinite
        disableDotsControls
        disableButtonsControls  
        autoPlay
    />
  )
}

export default Carousel
